import PropTypes from 'prop-types';
import { memo } from 'react';
import { Svg } from '../common/Svg.js';
import { locationParamNames } from '../common/locationUtils.js';

// Maintaining this as a separate variable because there's no guarantee we will always want to support all of these and
// nothing else (right?). It's likely a future version of this component will want to clone and edit this list.
const SUPPORTED_PARAMS = locationParamNames;

const buildSearchUrl = (searchParams, locationSearchParams) => {
    let searchUrl = baseURL + 'donors/search.html';

    // locationSearchParams is null, not empty, upon loading map-search
    if (locationSearchParams == null) {
        return searchUrl;
    }

    // Note that locationSearchParams holds what the user *told* us when typing in a location, not what we actually
    // searched for. It won't get updated by manual map-dragging, for example.
    const usedParams = SUPPORTED_PARAMS.filter((key) => locationSearchParams.hasOwnProperty(key));
    let queryString = usedParams.reduce((s, key) => {
        return s + `&${key}=${locationSearchParams[key]}`;
    }, '');

    if (queryString) {
        // Any clientside location-search should also specify `includeNearbyLocations=true`.
        queryString += '&includeNearbyLocations=true';

        searchUrl += '?' + queryString;
    }

    return searchUrl;
};

/**
 * A link back to regular-search, but formatted to look like a toggle-button.
 *
 * Aware of a few special search-location-params.
 */
export let SearchToggle = ({searchParams, locationSearchParams}) => {
    const searchUrl = buildSearchUrl(searchParams, locationSearchParams);
    return (
        <a className="search-toggle" href={searchUrl}>
            <div className="list"><Svg icon="list"/>List</div>
            <div className="map check"><Svg icon="location"/> Map</div>
        </a>
    );
}
SearchToggle.propTypes = {
    // See MapSearchResults
    searchParams: PropTypes.object.isRequired,
    // See MapSearchResults. Optional because this object is null and not empty on load.
    locationSearchParams: PropTypes.object,
}
SearchToggle = memo(SearchToggle);
